import {EventEmitter, Injectable} from '@angular/core';
import {cloneDeep} from 'lodash';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {findOperationsByNumeroPedido, getActivityAgrupado} from 'src/utils/roteirizacao-util';
import {calcularDistanciaEntreCoresDeltaE, convertArrayToString, extractStringByDelimiter, isNullOrEmpty, isNullOrUndefined} from 'src/utils/util';
import {EnderecoClienteModel, EntregaSequenciaModel, MapaEntregasModel} from '../../../models';
import {IndexedDbModel} from '../../../models/indexed-db.model';
import {ActivityModel, SoluctionModel} from '../../../models/planing';
import {RotaSequenciaDtoModel} from '../../../models/rota-sequencia-dto-model';
import {JanelaEntregaService} from '../../../services/janela-entrega.service';
import {EntregaPreCargaModel} from '../models/entregas-pre-carga.model';
import {MarkerAGM} from '../models/marker-agm';
import {PedidosPreCargaModel} from '../models/pedidos-pre-carga.model';
import {PreCargaCustoCarregamentoModel} from '../models/pre-carga-custo-carregamento.model';
import {PreCargaModel} from '../models/pre-carga.model';
import {TipoAgrupamento} from '../models/tipo-agrupamento.enum';
import {EntregaPreCargaService} from './entrega-pre-carga.service';
import {MapUtilsService} from './map-utils.service';
import {OverlayPreCargaService} from './overlay-pre-carga.service';
import {ParametroPortalService} from '../../../services/parametro-portal.service';
import {ParametrosPortalEnum} from '../../../enums/parametros.enum';
import {PreCargaDTO} from '../models/pre-carga-dto';
import * as moment from 'moment';
import {MensagensService} from 'max-ng-lib';
import {ParamEspecificoLocalStorageService} from './param-especifico-local-storage.service';
import {TripSoluctionModel} from '../../../models/trips';
import {debounceTime} from 'rxjs/operators';
import {InfoEntregasRotaModel} from '../../../models/info-entregas-rota.model';
import {TipoExibicaoClienteMapaModel} from '../models/tipo-exibicao-cliente-mapa.model';
import {SituacaoSalvarPreCarga} from '../models/situacao-salvar-pre-carga.model';
import * as uuid from 'uuid';

const uuidv4 = uuid.v4;


export enum SituacaoRoteirizacao {
  ROTEIRIZADO_COM_SOLUCAO,
  ROTEIRIZADO_COM_ERRO,
  CARREGAMENTO_GRAVADO,
  PENDENTE_ROTEIRIZACAO,
}

export const geradorNumAleatorio = (inferior, superior) => {
  const numPossibilidades = superior - inferior;
  let aleat = Math.random() * numPossibilidades;
  aleat = Math.floor(aleat);
  return Number.parseInt(inferior, 2) + aleat;
};

@Injectable({
  providedIn: 'root',
})
export class PreCargaService {
  idPrecarga = '0';
  removedPedidosEvent = new EventEmitter<{
    pedidos?: PedidosPreCargaModel[],
    preCargas: PreCargaModel[],
    naoFazerRecalculo?: boolean,
  }>();

  public listaInternaPreCargas: PreCargaModel[] = [];
  private listaInternaPreCargasComCarregamentosGravados: PreCargaModel[] = [];
  public copiaPreCargasAntesDaTransferencia: PreCargaModel[] = [];

  public preCargaAntiga: PreCargaModel[] = [];
  public verificaRota = false;
  public carregarPreCargaDataSource = new EventEmitter();

  public atualizarContagemCarregamentoMontagemEvent = new EventEmitter<number>();
  public onRemocaoPinDaPrecarga = new EventEmitter<MarkerAGM>();
  private onPreCargaAtualizada = new EventEmitter();
  tipoExibicaoClienteMapa: TipoExibicaoClienteMapaModel = TipoExibicaoClienteMapaModel.TODOS;

  public onAtualizarPrimeiraEntregaDaPrecarga = new EventEmitter<MarkerAGM>();

  constructor(
    private dbService: NgxIndexedDBService,
    private entregaPreCargaService: EntregaPreCargaService,
    private mapUtilService: MapUtilsService,
    private janelaEntregaService: JanelaEntregaService,
    private parametroService: ParametroPortalService,
    public overlayPreCargaService: OverlayPreCargaService,
    public mensageService: MensagensService,
    private paramEspecificoLocalStorageService: ParamEspecificoLocalStorageService
  ) {
    this.carregarListaStorage();

    this.escutarAtualizacaoPrecargaStorage();
  }

  private carregarListaStorage() {
    try {
      this.dbService
        .getAll(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_PRECARGAS)
        .subscribe((resposta) => {
          if (resposta.length) {
            const value = JSON.parse(resposta[0].conteudo);

            if (value !== null) {
              value.forEach((precarga) => {
                (precarga.listaMarkers || []).forEach((marcadores) => {
                  marcadores.openInfoWindow = new EventEmitter();
                });

                // A tela foi recarregada enquanto o carregamento era validado/gravado, não há mais como acompanhar o retorno
                if (precarga.isProcessoSalvar && this.preCargaSalvamentoEmAndamento(precarga)) {
                  precarga.situacaoSalvar = SituacaoSalvarPreCarga.ERRO;
                  precarga.pendenciaSalvar = null;
                  precarga.mensagemSalvar = 'O salvamento foi interrompido porque a tela foi recarregada. ' +
                    'Verifique em Consultas se o carregamento foi gerado antes de devolver a pré-carga para montagem.';
                }
              });
              this.listaInternaPreCargas = value;
              this.preCargaAntiga = [...value];
              this.verificaRota = true;
              this.idPrecarga = uuidv4();
            }
          }
        });
    } catch (error) {
      console.log(error.message);
    }
  }

  public removerPrecargaStorage() {
    try {
      this.dbService
        .clear(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_PRECARGAS)
        .subscribe(() => {
        });
    } catch (error) {
      console.log(error.message);
    }
  }

  public atualizarListaPrecargaStorage() {
    this.onPreCargaAtualizada.emit(this.listaInternaPreCargas);

  }

  private escutarAtualizacaoPrecargaStorage() {
    this.onPreCargaAtualizada.pipe(debounceTime(5000)).subscribe(() => {
      try {
        this.dbService
          .clear(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_PRECARGAS).pipe(debounceTime(5000))
          .subscribe(() => {
            const listaPreCargasString = {conteudo: this.serializarSemReferenciasDosMarcadores(this.listaInternaPreCargas)};
            this.dbService
              .add(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_PRECARGAS, listaPreCargasString)
              .subscribe(() => {
              });

            this.atualizarContagemCarregamentoMontagemEvent.emit(this.listaInternaPreCargas.length);
            this.carregarPreCargaDataSource.emit();
          });
      } catch (error) {
        console.log(error.message);
      }
      return true;
    });
  }

  /**
   * Serializa a lista para o IndexedDB com openInfoWindow/overlayPreCarga dos markers como null.
   * Antes era feito um cloneDeep de toda a lista (inclusive dos overlays do Google Maps) só para anular
   * esses campos antes do JSON.stringify; o replacer produz o mesmo JSON sem a cópia.
   */
  private serializarSemReferenciasDosMarcadores(listaPreCargas: Array<PreCargaModel>): string {
    const marcadores = new Set<any>();
    listaPreCargas.forEach((precarga) => {
      (precarga.listaMarkers || []).forEach((marcador) => marcadores.add(marcador));
    });
    return JSON.stringify(listaPreCargas, function(chave, valor) {
      if ((chave === 'openInfoWindow' || chave === 'overlayPreCarga') && marcadores.has(this)) {
        return null;
      }
      return valor;
    });
  }

  get listaPreCargas(): Array<PreCargaModel> {
    this.totalizarInformacoesPedidosPorPreCarga();
    return this.listaInternaPreCargas;
  }

  get listaPreCargasComCarregamentoGravado(): Array<PreCargaModel> {
    this.totalizarInformacoesPedidosPorPreCargaComCarregamentoGravado();
    return this.listaInternaPreCargasComCarregamentosGravados;
  }

  public existeCarregamentoGravadoNestaSecao(): boolean {
    return this.listaInternaPreCargasComCarregamentosGravados &&
      this.listaInternaPreCargasComCarregamentosGravados.length > 0;

  }

  addPreCarga(preCargaModel: PreCargaModel) {

    this.idPrecarga = uuidv4();

    preCargaModel.id = uuidv4();
    if (preCargaModel.cargaUnificada) {
      this.listaInternaPreCargas.unshift(preCargaModel);
    } else {
      this.listaInternaPreCargas.push(preCargaModel);
    }
    this.atualizarListaPrecargaStorage();
  }

  addPreCargaComCarregamentoGravado(preCargaModel: PreCargaModel) {
    preCargaModel.select = false;
    this.listaInternaPreCargasComCarregamentosGravados.push(preCargaModel);
  }

  updatePreCarga(preCargaModel: PreCargaModel) {
    const updateItem = this.listaInternaPreCargas.find(({id}) => id === preCargaModel.id);
    const index = this.listaInternaPreCargas.indexOf(updateItem);
    this.listaInternaPreCargas[index] = preCargaModel;
    this.atualizarListaPrecargaStorage();
  }

  addPreCargaAgrupamento(listaPreCargaModel: PreCargaModel[]) {
    listaPreCargaModel.forEach(preCarga => this.listaInternaPreCargas.push(preCarga));
    this.atualizarListaPrecargaStorage();
  }

  adicionarPreCargaJaConfigurada(preCargaModel: PreCargaModel) {
    this.listaInternaPreCargas.push(preCargaModel);
    this.atualizarListaPrecargaStorage();
  }

  removerClientesSemPedidosDaListaDaPrecarga() {
    const novaLista: PreCargaModel[] = [];
    this.listaInternaPreCargas.forEach((preCarga) => {
      const listaEntregasAtualizada: EntregaPreCargaModel[] = [];
      const listaMarkersAtualizada: MarkerAGM[] = [];

      preCarga.listaEntregas.forEach((entrega) => {
        if (isNullOrEmpty(entrega.pedidos) && !entrega.isPontoParada && !entrega.isPontoPassagem) {
          return;
        }
        listaEntregasAtualizada.push(entrega);

        let marker: MarkerAGM;
        if (!isNullOrEmpty(entrega.idEnderecoEntrega) && entrega.idEnderecoEntrega !== '0') {
          marker = preCarga.listaMarkers.filter((m) => m.cliente.id === entrega.idCliente &&
            m.cliente.idEndEntrega === entrega.idEnderecoEntrega)[0];
        } else {
          marker = preCarga.listaMarkers.filter((m) => m.cliente.id === entrega.idCliente &&
            (isNullOrEmpty(m.cliente.idEndEntrega) || m.cliente.idEndEntrega === '0'))[0];
        }
        listaMarkersAtualizada.push(marker);
      });

      if (listaEntregasAtualizada.length != preCarga.listaEntregas.length) {
        preCarga.listaEntregas = listaEntregasAtualizada;
        preCarga.listaMarkers = listaMarkersAtualizada;
        preCarga.sequenciarNovamente = true;

        if (preCarga.preCargaDTO && preCarga.preCargaDTO.clientes) {
          preCarga.preCargaDTO.clientes = preCarga.preCargaDTO.clientes.filter((c) => c.listaPedidos.length > 0);
        }
      }

      novaLista.push(preCarga);
    });

    this.listaInternaPreCargas = novaLista;
    this.atualizarListaPrecargaStorage();
  }

  removePreCarga(preCargaModel: PreCargaModel) {

    const index = this.listaInternaPreCargas.findIndex((p) => p.id === preCargaModel.id);

    if (index >= 0) {
      this.listaInternaPreCargas.splice(index, 1);
      this.preCargaAntiga.splice(index, 1);
      this.mapUtilService.removerRotaPreCarga(preCargaModel.id);
      this.overlayPreCargaService.removerOverlay(preCargaModel);
      this.atualizarListaPrecargaStorage();
    }

    if (this.preCargaAntiga.length < 1) {
      this.verificaRota = false;
    }
  }

  removePreCargaComCarregamentoGravado(preCargaModel: PreCargaModel) {
    const index = this.listaInternaPreCargasComCarregamentosGravados.findIndex(
      (p) => p.id === preCargaModel.id
    );
    if (index >= 0) {
      this.listaInternaPreCargasComCarregamentosGravados.splice(index, 1);
      this.preCargaAntiga.splice(index, 1);
      this.atualizarListaPrecargaStorage();
    }

    if (this.preCargaAntiga.length < 1) {
      this.verificaRota = false;
    }
  }

  removerTodasPreCargas() {
    this.listaInternaPreCargas = [];
    this.preCargaAntiga = [];
    this.idPrecarga = '0';
    this.removerPrecargaStorage();
  }

  limparListaPreCargas() {
    this.listaInternaPreCargas = [];
    this.removerPrecargaStorage();
  }

  // Pré-cargas em processo de salvamento não podem ser descartadas, o retorno do backend ainda depende delas
  limparListaPreCargasExcetoEmProcessoSalvar() {
    const preCargasEmProcessoSalvar = this.listaInternaPreCargas.filter(p => p.isProcessoSalvar);
    this.limparListaPreCargas();
    this.listaInternaPreCargas = preCargasEmProcessoSalvar;

    if (preCargasEmProcessoSalvar.length) {
      this.atualizarListaPrecargaStorage();
    }
  }

  obterMarkersEmProcessoSalvar(): Set<MarkerAGM> {
    return new Set(
      this.listaInternaPreCargas
        .filter(p => p.isProcessoSalvar)
        .reduce((acc, p) => acc.concat(p.listaMarkers || []), [])
    );
  }

  obterNumerosPedidosEmProcessoSalvar(): Set<number> {
    return new Set(
      this.listaInternaPreCargas
        .filter(p => p.isProcessoSalvar)
        .reduce((acc, p) => acc.concat(this.obterListaPedidosPrecarga(p) || []), [])
        .map(pedido => pedido.numeroPedido)
    );
  }

  removerPreCargasNaoRoteirizadas() {
    this.listaInternaPreCargas = this.listaInternaPreCargas.filter(preCarga =>
      preCarga.isProcessoSalvar || this.preCargaRoteirizadaCorretamente(preCarga));
    this.mapUtilService.removerTrajetoRotaTodasPreCargas();
  }

  configurarPorAgrupamento(tipoAgrupamento: TipoAgrupamento) {
    if (tipoAgrupamento === TipoAgrupamento.ROTA) {
      if (this.verificaRota === true) {
        this.preCargaAntiga = this.listaInternaPreCargas;
      } else {
        this.preCargaAntiga = [];
        this.verificaRota = true;
      }
    } else {
      this.preCargaAntiga = [];
      this.verificaRota = false;
    }
  }

  clienteJaAdicionadoEmUmaPreCarga(
    idCliente,
    idEnderecoEntrega,
    pedidos: Array<PedidosPreCargaModel>
  ) {
    const pedido = pedidos.sort((a, b) => a.numeroPedido - b.numeroPedido).map((p) => p.numeroPedido).toString();

    let exist = false;
    for (const l of this.listaInternaPreCargas) {
      exist =
        l.listaEntregas.filter((e) => {
          return (
            e.idCliente === idCliente &&
            e.idEnderecoEntrega === idEnderecoEntrega &&
            e.pedidos.sort((a, b) => a.numeroPedido - b.numeroPedido)
              .map((p) => p.numeroPedido)
              .toString()
              .includes(pedido)
          );
        }).length > 0;

      if (exist) {
        break;
      }
    }
    return exist;
  }

  existePreCargaRoteirizacaoEmAndamento() {
    return this.obterListaPreCargaRoteirizacaoEmAndamento().length > 0;
  }

  obterListaPreCargaRoteirizacaoEmAndamento() {
    return this.listaInternaPreCargas.filter((p) =>
      this.processoRoteirizacaoFinalizadoParaPrecarga(p)
    );
  }

  private processoRoteirizacaoFinalizadoParaPrecarga(p: PreCargaModel) {
    return (
      p.problemPreCargaDTOModel &&
      !p.problemPreCargaDTOModel.processoRoteirizacaoFinalizado
    );
  }

  existePreCargaRoteirizadaSemSolucao() {
    return this.obterListaPreCargaRoteirizacaoSemSolucao().length > 0;
  }

  obterListaPreCargaRoteirizacaoSemSolucao() {
    return this.listaInternaPreCargas.filter(
      (p) =>
        p.problemPreCargaDTOModel &&
        p.problemPreCargaDTOModel.problemaResolvido &&
        !p.preCargaDTO.solucao
    );
  }

  /**
   * @param indicePreCargaPorPedido índice opcional (ver criarIndicePreCargaPorNumeroPedido) para evitar
   * percorrer todas as pré-cargas a cada pedido quando o método é chamado em loop
   */
  atualizaPrecargaNoPedidoDoMarker(marker: MarkerAGM, indicePreCargaPorPedido?: Map<number, PreCargaModel>) {
    marker.pedidos.forEach((pedido) => {
      const precarga: PreCargaModel = indicePreCargaPorPedido
        ? indicePreCargaPorPedido.get(pedido.numeroPedido)
        : this.obterPrecargaDoPedido(pedido.numeroPedido);
      pedido.idPrecarga = precarga ? precarga.id : null;
    });
  }

  /**
   * Índice numeroPedido -> pré-carga. Em caso de pedido em mais de uma pré-carga, mantém a primeira da lista,
   * mesmo comportamento de obterPrecargaDoPedido.
   */
  criarIndicePreCargaPorNumeroPedido(): Map<number, PreCargaModel> {
    const indice = new Map<number, PreCargaModel>();
    (this.listaInternaPreCargas || []).forEach(precarga => {
      (precarga.listaEntregas || []).forEach(entrega => {
        (entrega.pedidos || []).forEach(pedido => {
          if (!indice.has(pedido.numeroPedido)) {
            indice.set(pedido.numeroPedido, precarga);
          }
        });
      });
    });
    return indice;
  }

  /**
   * <pre>
   * Atualiza o valor da flag janelaEntregaHabilitada dentro do local storage
   *
   * Atualiza o valor da flag de zona de risco no local storage
   * especificamente no marker que veio por parâmetro de acordo com a pré-carga
   * </pre>
   */
  async atualizaMarkerPrecarga(marker: MarkerAGM, endereco?: any) {
    const updateItemPreCarga = this.listaInternaPreCargas.find(
      (x) => x.id === marker.idPreCarga
    );
    const indexPreCarga =
      this.listaInternaPreCargas.indexOf(updateItemPreCarga);
    const updateItemMarker = this.listaInternaPreCargas[
      indexPreCarga
      ].listaMarkers.find((x) => x.id === marker.id);
    const indexMarker =
      this.listaInternaPreCargas[indexPreCarga].listaMarkers.indexOf(
        updateItemMarker
      );

    const {id, idEndEntrega} = marker.cliente;

    const updateEntrega = this.listaInternaPreCargas[indexPreCarga].listaEntregas.find((e) => e.idEnderecoEntrega == idEndEntrega && e.idCliente === id);

    const updateCliente = this.listaInternaPreCargas[indexPreCarga].preCargaDTO.clientes.find((c) => c.id === id && c.idEnderecoEntrega === idEndEntrega);

    const indexEntrega = this.listaInternaPreCargas[indexPreCarga].listaEntregas.indexOf(updateEntrega);

    const indexCliente = this.listaInternaPreCargas[indexPreCarga].preCargaDTO.clientes.indexOf(updateCliente);

    updateEntrega.latitude = marker.latitude;
    updateEntrega.longitude = marker.longitude;

    const novoEndereco = {
      numero: endereco.numero,
      bairro: endereco.bairro,
      cep: endereco.cep,
      cidade: endereco.municipio,
      endereco: endereco.endereco,
    };

    if (endereco && updateEntrega.endereco) {
      updateEntrega.endereco.numero = novoEndereco.numero;
      updateEntrega.endereco.bairro = novoEndereco.bairro;
      updateEntrega.endereco.cep = novoEndereco.cep;
      updateEntrega.endereco.cidade = novoEndereco.cidade;
      updateEntrega.endereco.endereco = novoEndereco.endereco;
    } else {
      updateEntrega.endereco = novoEndereco;
    }

    updateCliente.latitude = marker.latitude;
    updateCliente.longitude = marker.longitude;

    this.listaInternaPreCargas[indexPreCarga].preCargaDTO.clientes[indexCliente] = updateCliente;

    this.listaInternaPreCargas[indexPreCarga].listaEntregas[indexEntrega] = updateEntrega;

    this.listaInternaPreCargas[indexPreCarga].listaMarkers[indexMarker] =
      marker;
    this.atualizarListaPrecargaStorage();
  }

  obterMarkersDaPreCarga(preCarga: PreCargaModel) {
    if (preCarga.listaMarkers) {
      return preCarga.listaMarkers;
    }
    return null;
  }

  obterListaClientesSelecionados() {
    const entregasClienteSelecionadas: EntregaPreCargaModel[] = [];

    for (const preCarga of this.listaPreCargas) {
      const entregas = preCarga.listaEntregas.filter((e) => e.select);

      if (!entregas.length) {
        continue;
      }

      entregasClienteSelecionadas.push(...entregas);
    }

    return entregasClienteSelecionadas;
  }

  removerSelecaoDosPedidos() {
    this.obterListaPedidosSelecionados().forEach((e) => {
      e.select = false;
    });
  }


  obterPedidosDosClientesSelecionados() {
    const entregas = this.obterListaClientesSelecionados();

    const pedidos = entregas.reduce((a, b) => a.concat(b.pedidos), []);

    return pedidos;
  }

  obterListaPrecargasSelecionadas() {
    return this.listaPreCargas.filter((p) => p.select);
  }

  obterListaPedidosDasPrecargas(): PedidosPreCargaModel[] {
    const listaDePedidos: PedidosPreCargaModel[] = [];

    this.listaPreCargas.forEach((preCarga) => {
      listaDePedidos.push(...this.obterListaPedidosPrecarga(preCarga));
    });

    return listaDePedidos;
  }

  obterListaPedidosDasPrecargasPorIds(idsPrecarga: Set<string>): PedidosPreCargaModel[] {
    if (!idsPrecarga || idsPrecarga.size === 0) return [];

    const listaDePedidos: PedidosPreCargaModel[] = [];

    for(const id of idsPrecarga) {
      const preCarga = this.listaPreCargas.find((preCarga) => preCarga.id === id);
      if (preCarga) {
        listaDePedidos.push(...this.obterListaPedidosPrecarga(preCarga));
      }
    }

    return listaDePedidos;
  }

  precargaSemPedido(preCarga) {
    if (!preCarga.listaEntregas || !preCarga.listaEntregas.length) return true;

    for (const entrega of preCarga.listaEntregas) {
      if (entrega.pedidos && entrega.pedidos.length) return false;
    }
    return true;
  }

  obterListaPedidosPrecarga({ listaEntregas, id, listaMarkers }: PreCargaModel): PedidosPreCargaModel[] {
    if (!listaEntregas || listaEntregas.length === 0) return [];

    const markerMap = new Map<string, any>();
    if (Array.isArray(listaMarkers)) {
      for (const marker of listaMarkers) {
        if (marker && marker.cliente) {
          const key = `${marker.cliente.id}_${marker.cliente.idEndEntrega}`;
          markerMap.set(key, marker.cliente);
        }
      }
    }

    const listaDePedidos: PedidosPreCargaModel[] = [];

    for (const entrega of listaEntregas) {
      if (!entrega.pedidos) continue;

      for (const pedido of entrega.pedidos) {
        pedido.idPrecarga = id;

        const key = `${pedido.idCliente}_${pedido.idEnderecoEntrega}`;
        const cliente = markerMap.get(key);

        if (cliente) {
          pedido.idRegiao = cliente.idRegiao;
          pedido.idPraca = cliente.idPraca;
          pedido.praca = cliente.praca;
          pedido.idRota = cliente.idRota;
          pedido.descricaoRota = cliente.descricaoRota;
          pedido.pontoReferencia = cliente.pontoReferencia;
        }

        listaDePedidos.push(pedido);
      }
    }

    return listaDePedidos;
  }

  obterListaEntregasPrecarga(idPreCarga: string): EntregaPreCargaModel[] {
    const preCarga = this.obterPreCargaPorId(idPreCarga);

    if (!preCarga.listaEntregas || !preCarga.listaEntregas.length) {
      return [];
    }

    for (const entrega of preCarga.listaEntregas) {
      entrega.peso = entrega.pedidos.reduce((acc, c) => acc + c.pesoTotal, 0);
      entrega.volume = entrega.pedidos.reduce((acc, c) => acc + c.volumeTotal, 0);
      entrega.valor = entrega.pedidos.reduce((acc, c) => acc + c.valorTotal, 0);

      entrega.endereco = {
        endereco: entrega.pedidos[0].endereco,
        numero: entrega.pedidos[0].numero,
        bairro: entrega.pedidos[0].bairro,
        cidade: entrega.pedidos[0].cidade,
        cep: entrega.pedidos[0].cep,
      }
      entrega.cgc = entrega.pedidos[0].cgcent,
      entrega.ramoAtividade = entrega.pedidos[0].ramoAtividade
      entrega.destino = preCarga.destino;
      entrega.idPrecarga = preCarga.id;
    }

    return preCarga.listaEntregas;
  }

  private obterPedidoCustom(pedido:PedidosPreCargaModel, markerFound:MarkerAGM) {
    pedido.idRegiao = markerFound.cliente.idRegiao;
    pedido.idPraca = markerFound.cliente.idPraca;
    pedido.praca = markerFound.cliente.praca;
    pedido.idRota = markerFound.cliente.idRota;
    pedido.descricaoRota = markerFound.cliente.descricaoRota;

    return pedido;
  }

  async selecionarPedidosComCarregamento(pedidos) {
    return new Promise((resolve) => {
      for (const ped of pedidos) {
        for (const p of this.listaPreCargas) {
          for (const e of p.listaEntregas) {
            for (const pedido of e.pedidos) {
              if (ped == pedido.numeroPedido) {
                pedido.select = true;
              }
            }
          }
        }
      }
      resolve(true);
    });
  }

  public removePedidosSelecionadosDaPrecarga(pedidos?: PedidosPreCargaModel[]): void {
    (pedidos || this.obterListaPedidosSelecionados()).forEach((pedido) => {
      this.listaPreCargas.forEach((preCarga) => {

        if (preCarga.preCargaDTO && preCarga.preCargaDTO.solucao) {
          const solucao = preCarga.preCargaDTO.solucao;
          const {DELIVERY} = getActivityAgrupado(solucao.vehicleRoutes);
          const findOperations = findOperationsByNumeroPedido(pedido.numeroPedido);
          const deliveryOperations = DELIVERY.find(findOperations);
          if (deliveryOperations) {
            const {operations} = deliveryOperations;
            const indexOperation = operations.findIndex((numeroPedido) => numeroPedido == pedido.numeroPedido);
            (indexOperation > -1) && operations.splice(indexOperation, 1);
          }

          preCarga.preCargaDTO.clientes.forEach(({listaPedidos, idsPedidos}) => {
            const indexPedidoPreCargaDto = listaPedidos.findIndex(p => p.id.toString() == pedido.numeroPedido);
            if (indexPedidoPreCargaDto > -1) {
              listaPedidos.splice(indexPedidoPreCargaDto, 1);
              idsPedidos.splice(indexPedidoPreCargaDto, 1);
            }
          });
        }

        preCarga.listaEntregas.forEach((entrega) => {
          const index = entrega.pedidos.findIndex(
            (p) => p.numeroPedido === pedido.numeroPedido
          );
          if (index >= 0) {
            entrega.pedidos.splice(index, 1);
            preCarga.distribuicaoAutomatica = false;
          }
        });
      });
    });

    this.removerClientesSemPedidosDaListaDaPrecarga();
  }

  public removePedidosSelecionadosDaPrecargaMarker(markesSelecionados): void {
    let pedidos = [];

    if (markesSelecionados != null) {
      pedidos = markesSelecionados.map((m) => m.pedidos).flat();
    } else {
      pedidos = this.obterListaPedidosSelecionados();
    }

    pedidos.forEach((pedido) => {
      this.listaPreCargas.forEach((preCarga) => {
        if (preCarga.preCargaDTO && preCarga.preCargaDTO.solucao && !preCarga.preCargaDTO.solucao.routeError) {
          const solucao = preCarga.preCargaDTO.solucao;
          const {DELIVERY} = getActivityAgrupado(solucao.vehicleRoutes);
          const findOperations = findOperationsByNumeroPedido(pedido.numeroPedido);
          const deliveryOperations = DELIVERY.find(findOperations);
          if (deliveryOperations) {
            const {operations} = deliveryOperations;
            const indexOperation = operations.findIndex((numeroPedido) => numeroPedido == pedido.numeroPedido);
            (indexOperation > -1) && operations.splice(indexOperation, 1);
          }

          preCarga.preCargaDTO.clientes.forEach(({listaPedidos, idsPedidos}) => {
            const indexPedidoPreCargaDto = listaPedidos.findIndex(p => p.id.toString() == pedido.numeroPedido);
            if (indexPedidoPreCargaDto > -1) {
              listaPedidos.splice(indexPedidoPreCargaDto, 1);
              idsPedidos.splice(indexPedidoPreCargaDto, 1);
            }
          });
        }

        preCarga.listaEntregas.forEach((entrega) => {
          const index = entrega.pedidos.findIndex(
            (p) => p.numeroPedido === pedido.numeroPedido
          );
          if (index >= 0) {
            entrega.pedidos.splice(index, 1);
            preCarga.distribuicaoAutomatica = false;
          }
        });
      });
    });

    this.removerClientesSemPedidosDaListaDaPrecarga();
  }


  public removeMarkerDaPrecargaOrigem() {
    const precargasOrigem = [];
    this.listaPreCargas.forEach((preCarga) => {
      const novaListaMarker: MarkerAGM[] = [];

      preCarga.listaMarkers.forEach((marker) => {
        let contPedidosTransf = 0;

        this.obterListaPedidosSelecionados().forEach((pedido) => {
          const index = marker.pedidos.findIndex(
            (p) => p.numeroPedido === pedido.numeroPedido
          );
          if (index >= 0) {
            contPedidosTransf++;
          }
        });

        if (contPedidosTransf !== marker.pedidos.length) {
          novaListaMarker.push(marker);
        }

        if (contPedidosTransf > 0) {
          precargasOrigem.push(preCarga);
        }
      });

      preCarga.listaMarkers = novaListaMarker;
    });

    return precargasOrigem;
  }


  public removeMarkerDaPrecargaOrigemMarker(markesSelecionados, idPrecarga) {
    const precargasOrigem = [];
    this.listaPreCargas.forEach((preCarga) => {
        if (preCarga.id !== idPrecarga) {
          const markersBefore = [...preCarga.listaMarkers];
          preCarga.listaMarkers = preCarga.listaMarkers.filter((m) => !markesSelecionados.includes(m));
          if (markersBefore.length !== preCarga.listaMarkers.length) {
            precargasOrigem.push(preCarga);
          }
        }
      }
    );
    return precargasOrigem;
  }

  situcaoRoteirizacao(preCarga: PreCargaModel) {
    if (this.preCargaCarregamentoGravado(preCarga)) {
      return SituacaoRoteirizacao.CARREGAMENTO_GRAVADO;
    } else if (this.preCargaRoteirizadaCorretamente(preCarga)) {
      return SituacaoRoteirizacao.ROTEIRIZADO_COM_SOLUCAO;
    } else if (this.preCargaComFalhaNaRoteirizacao(preCarga)) {
      return SituacaoRoteirizacao.ROTEIRIZADO_COM_ERRO;
    } else {
      return SituacaoRoteirizacao.PENDENTE_ROTEIRIZACAO;
    }
  }

  preCargaRoteirizadaCorretamente(preCarga: PreCargaModel) {
    return preCarga &&
      preCarga.preCargaDTO &&
      preCarga.preCargaDTO.solucao &&
      !this.preCargaComFalhaNaRoteirizacao(preCarga);
  }

  preCargaComFalhaNaRoteirizacao(preCarga: PreCargaModel) {
    return preCarga.problemPreCargaDTOModel &&
      preCarga.problemPreCargaDTOModel.errors != null &&
      preCarga.problemPreCargaDTOModel.errors.length > 0;
  }

  preCargaProntaParaGravar(preCarga: PreCargaModel) {
    return (
      preCarga.preCargaDTO &&
      preCarga.preCargaDTO.solucao &&
      (!preCarga.carregamentoGravadoDTO ||
        !preCarga.carregamentoGravadoDTO.id) &&
      !this.preCargaComFalhaNaRoteirizacao(preCarga)
    );
  }

  preCargaCarregamentoGravado(preCarga: PreCargaModel) {
    return (
      preCarga.hasOwnProperty('carregamentoGravadoDTO') &&
      preCarga.carregamentoGravadoDTO &&
      preCarga.carregamentoGravadoDTO.id &&
      preCarga.carregamentoGravadoDTO.id > 0
    );
  }

  preCargaCarregamentoRoteirizado(preCarga: PreCargaModel) {
    return (
      preCarga &&
      preCarga.preCargaDTO &&
      preCarga.preCargaDTO.solucao &&
      preCarga.preCargaDTO.solucao.id &&
      !preCarga.preCargaDTO.solucao.routeError &&
      (!preCarga.problemPreCargaDTOModel ||
        !preCarga.problemPreCargaDTOModel.errors ||
        !preCarga.problemPreCargaDTOModel.errors.length)
    );
  }

  preCargaCarregamentoPontoPassagem(preCarga: PreCargaModel) {
    return (preCarga.listaEntregas.some(e => e.isPontoPassagem));
  }

  removerPontoPassagemPreCarga(listaPreCargas: PreCargaModel []) {

    listaPreCargas = listaPreCargas.filter(preCarga => {
      preCarga.listaEntregas = preCarga.listaEntregas.filter(e => !e.isPontoPassagem);
      preCarga.listaMarkers = preCarga.listaMarkers.filter(m => !m.isPontoPassagem);
      return preCarga.listaEntregas.length > 0;
    });

    listaPreCargas.forEach(p => {
      p.problemPreCargaDTOModel = null;
      p.preCargaDTO = null;
    });
  }

  public obterPreCargasSemCarregamentoGravado(): PreCargaModel[] {
    return this.listaPreCargas.filter(
      (p) => !this.preCargaCarregamentoGravado(p)
    );
  }

  preCargaEmRoteirizacao(preCarga: PreCargaModel) {
    return (
      preCarga.problemPreCargaDTOModel &&
      preCarga.problemPreCargaDTOModel.emRoteirizacao
    );
  }

  obterPreCargaPeloProblemRoteirizacao(problema) {
    const pre = this.obterListaPreCargaRoteirizacaoEmAndamento().filter(
      (e) => e.problemPreCargaDTOModel.idProblem === problema.id
    );
    return pre && pre.length > 0 ? pre[0] : null;
  }

  obterPedidosDaPreCargaGridPedidos(preCarga: PreCargaModel): PedidosPreCargaModel[] {
    return this.obterListaPedidosPrecarga(preCarga);
  }

  obterEntregasDaPreCargaGridClientes(idPreCarga: string): EntregaPreCargaModel[] {
    return this.obterListaEntregasPrecarga(idPreCarga);
  }

  obterPedidosDaPreCargaCarregamentoGravadoGridPedidos(
    preCarga: PreCargaModel
  ): PedidosPreCargaModel[] {
    const pedidos = [];
    if (!isNullOrEmpty(preCarga.listaEntregas)) {
      this.obterListaPedidosPrecarga(preCarga).forEach((p) => {
        p.disabled = true;
        p.select = false;
        pedidos.push(p);
      });
    }
    return pedidos;
  }

  removeSelectPreCargas(): void {
    this.listaInternaPreCargas.forEach((p) => {
      p.select = false;
    });
  }

  private obterCoresParaDistinguir() {
    const coresPadrao = [
      '#FFFFFF',
      this.mapUtilService.getCorMarker('PADRAO'),
      this.mapUtilService.getCorMarker('JANELAENTREGA'),
      this.mapUtilService.getCorMarker('OBSERVACAO'),
      this.mapUtilService.getCorMarker('ZONARISCO'),
      this.mapUtilService.getCorMarker('CLIENTEBLOQUEADO'),
      this.mapUtilService.getCorMarker('AGENDAMENTO'),
      this.mapUtilService.getCorMarker('AVULSO'),
    ]

    return [...this.listaInternaPreCargas.map((p) => p.cor), ...coresPadrao];
  }

  gerarCorAleatoria(coresParaDistinguir?: string[]) {
    const coresPadraoEDasPreCargas = this.obterCoresParaDistinguir().concat(coresParaDistinguir || []);
    // Converte para RGB uma vez só (antes era refeito para cada cor em cada tentativa)
    const coresRGB: [number, number, number][] = coresPadraoEDasPreCargas
      .filter((cor) => !!cor)
      .map((cor): [number, number, number] => [
      parseInt(cor.substring(1, 3), 16),
      parseInt(cor.substring(3, 5), 16),
      parseInt(cor.substring(5, 7), 16),
    ]);

    const minDeltaE = 15;
    const maxTentativas = coresPadraoEDasPreCargas.length + 100;
    let newColor: [number, number, number];
    let count = 0;

    do {
      count++;
      newColor = [
        Math.floor(Math.random() * 256),
        Math.floor(Math.random() * 256),
        Math.floor(Math.random() * 256),
      ];
    } while (
      count <= maxTentativas &&
      coresRGB.some(corRGB => {
        const delta = calcularDistanciaEntreCoresDeltaE(corRGB, newColor);

        return delta < minDeltaE;
      })
    );

    const hexColor = `#${newColor[0].toString(16).padStart(2, '0')}${newColor[1]
      .toString(16)
      .padStart(2, '0')}${newColor[2].toString(16).padStart(2, '0')}`;

    return hexColor;
  }

  public getDataEntregaDefault() {
    const dataInicial = new Date();
    this.parametroService.obterParametroEspecifico({id: ParametrosPortalEnum.DATA_ENTREGA_DIA_ATUAL}).subscribe(resultado => {
      if (resultado.valor === 'N') {
        dataInicial.setDate(dataInicial.getDate() + 1);
      }
    });
    return dataInicial;
  }

  public adicionarDadosPedidosNaPreCarga(
    pedidos: PedidosPreCargaModel[],
    preCarga: PreCargaModel
  ) {
    // Índice idCliente -> idEnderecoEntrega -> pedidos (Map compara como ===, igual ao filtro anterior por idCliente e idEnderecoEntrega)
    const pedidosPorEntrega = new Map<any, Map<any, PedidosPreCargaModel[]>>();
    pedidos.forEach((p) => {
      let porEndereco = pedidosPorEntrega.get(p.idCliente);
      if (!porEndereco) {
        porEndereco = new Map();
        pedidosPorEntrega.set(p.idCliente, porEndereco);
      }
      const lista = porEndereco.get(p.idEnderecoEntrega);
      if (lista) {
        lista.push(p);
      } else {
        porEndereco.set(p.idEnderecoEntrega, [p]);
      }
    });
    preCarga.listaEntregas.forEach((e) => {
      const porEndereco = pedidosPorEntrega.get(e.idCliente);
      const lista = porEndereco && porEndereco.get(e.idEnderecoEntrega);
      // Cópia: cada entrega mantém o próprio array, como no filter original
      e.pedidos = lista ? lista.slice() : [];
    });
  }

  private totalizarInformacoesPedidosPorPreCarga() {
    this.listaInternaPreCargas.forEach((preCarga) => this.totalizarPreCarga(preCarga));
  }

  private totalizarPreCarga(preCarga: PreCargaModel) {
    preCarga.peso = 0;
    preCarga.volume = 0;
    preCarga.valor = 0;

    if (!isNullOrEmpty(preCarga.listaEntregas)) {
      preCarga.listaEntregas.forEach((entrega) => {
        if (!entrega.pedidos) {
          return;
        }
        entrega.pedidos.forEach((pedido) => {
          preCarga.peso += pedido.pesoTotal;
          preCarga.volume += pedido.volumeTotal;
          preCarga.valor += pedido.valorTotal;
        });
      });
    }
  }

  private totalizarInformacoesPedidosPorPreCargaComCarregamentoGravado() {
    this.listaInternaPreCargasComCarregamentosGravados.forEach((preCarga) => {
      preCarga.peso = 0;
      preCarga.volume = 0;
      preCarga.valor = 0;

      if (!isNullOrEmpty(preCarga.listaEntregas)) {
        preCarga.listaEntregas.forEach((entrega) => {
          if (!entrega.pedidos) {
            return;
          }
          entrega.pedidos.forEach((pedido) => {
            preCarga.peso += pedido.pesoTotal;
            preCarga.volume += pedido.volumeTotal;
            preCarga.valor += pedido.valorTotal;
          });
        });
      }
    });
  }

  obterPrecargaDoMarker(marker: MarkerAGM) {
    return this.totalizarPreCargaEncontrada(this.listaInternaPreCargas.find((p) => p.id === marker.idPreCarga));
  }

  obterPreCargaPorId(idPreCarga: string) {
    return this.totalizarPreCargaEncontrada(this.listaInternaPreCargas.find((p) => p.id === idPreCarga));
  }

  obterPreCargasPedidosDoMarker(marker: MarkerAGM) {
    const idsPreCargas = new Set(marker.pedidos.map((ped) => ped.idPrecarga));
    return this.totalizarPreCargasEncontradas(
      this.listaInternaPreCargas.filter((preCarga) => idsPreCargas.has(preCarga.id))
    );
  }

  obterPreCargaPorPedido(pedido: PedidosPreCargaModel) {
    return this.totalizarPreCargaEncontrada(this.listaInternaPreCargas.find((preCarga) => preCarga.id === pedido.idPrecarga));
  }

  obterPrecargasDoMarkers(markers: MarkerAGM[]) {
    const idsPreCargas = new Set<string>();
    markers.forEach((mark) => {
      idsPreCargas.add(mark.idPreCarga);
      mark.pedidos.forEach((ped) => idsPreCargas.add(ped.idPrecarga));
    });
    return this.totalizarPreCargasEncontradas(
      this.listaInternaPreCargas.filter((preCarga) => idsPreCargas.has(preCarga.id))
    );
  }

  obterPrecargaDoPedido(numeroPedido: number): PreCargaModel {
    return this.totalizarPreCargaEncontrada(this.listaInternaPreCargas.find(
      this.encontraPrecargaDoPedido(numeroPedido)
    ));
  }

  /**
   * As buscas pontuais usam a lista interna (o getter listaPreCargas totaliza TODAS as pré-cargas a cada acesso,
   * o que fica quadrático quando a busca é feita em loop) e totalizam apenas o que é retornado,
   * mantendo peso/volume/valor atualizados para quem chama.
   */
  private totalizarPreCargaEncontrada(preCarga: PreCargaModel): PreCargaModel {
    if (preCarga) {
      this.totalizarPreCarga(preCarga);
    }
    return preCarga;
  }

  private totalizarPreCargasEncontradas(preCargas: PreCargaModel[]): PreCargaModel[] {
    preCargas.forEach((preCarga) => this.totalizarPreCarga(preCarga));
    return preCargas;
  }

  private encontraPrecargaDoPedido(
    numeroPedido: number
  ): (value: PreCargaModel) => boolean {
    return precarga => (precarga.listaEntregas || []).some(
      entrega => (entrega.pedidos || []).some(
        pedido => pedido.numeroPedido === numeroPedido
      )
    );
  }

  public removerOrdemGridPrecargaStorage() {
    this.dbService
      .clear(IndexedDbModel.DB_ROTEIRIZACAO_ORDEM_GRID_PRECARGAS)
      .subscribe(() => {
      });
  }

  public atualizarOrdemGridPrecargaStorage(evento) {
    this.dbService
      .clear(IndexedDbModel.DB_ROTEIRIZACAO_ORDEM_GRID_PRECARGAS)
      .subscribe((res) => {
        this.dbService
          .add(IndexedDbModel.DB_ROTEIRIZACAO_ORDEM_GRID_PRECARGAS, evento)
          .subscribe();
      });
  }

  public carregarOrdemGridPrecargaStorage() {
    return this.dbService.getAll(
      IndexedDbModel.DB_ROTEIRIZACAO_ORDEM_GRID_PRECARGAS
    );
  }

  public obteridEntrega(idCliente, idEnderecoEntrega) {
    if (!idCliente) {
      return '';
    }
    const strEnderecoEntrega = idEnderecoEntrega ? `_${idEnderecoEntrega}` : '';
    return `${idCliente}${strEnderecoEntrega}`;
  }

  public converterPreCargaParaPreCargaDTO(preCarga: PreCargaModel) {
    if (preCarga.preCargaDTO) {
      const dto: any = preCarga.preCargaDTO;
      dto.veiculo = preCarga.veiculo;
      dto.destino = preCarga.destino;
      dto.motorista = preCarga.motorista;
      dto.rotaInvertida = preCarga.rotaInvertida;
      dto.ajudante1 = preCarga.ajudante1;
      dto.ajudante2 = preCarga.ajudante2;
      dto.ajudante3 = preCarga.ajudante3;
      dto.peso = preCarga.peso;
      dto.observacao = preCarga.observacao;
      dto.volume = preCarga.volume;
      dto.valor = preCarga.valor.toFixed(2);
      dto.custoRomaneioTerceirizado = preCarga.custoRomaneioTerceirizado;
      dto.salvarCarregamentoComSituacaoBloqueado = preCarga.salvarCarregamentoComSituacaoBloqueado;
      dto.calcularTempoSaida = preCarga.calcularTempoSaida;
      dto.tipoPontoChegada = preCarga.tipoPontoChegada;
      dto.pontoChegada = preCarga.pontoChegada;
      dto.considerarDataPedidoPorCidade = preCarga.considerarDataPedidoPorCidade;

      if (preCarga.custoCarregamento) {
        dto.custoCarregamento = this.converterCustoCarregamentoModelParaCustoDTO(
          preCarga.custoCarregamento
        );
      }

      dto.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      return dto;
    } else {
      return {
        veiculo: preCarga.veiculo,
        destino: preCarga.destino,
        motorista: preCarga.motorista,
        rotaInvertida: preCarga.rotaInvertida,
        ajudante1: preCarga.ajudante1,
        ajudante2: preCarga.ajudante2,
        ajudante3: preCarga.ajudante3,
        peso: preCarga.peso,
        observacao: preCarga.observacao,
        volume: preCarga.volume,
        valor: preCarga.valor.toFixed(2),
        custoRomaneioTerceirizado: preCarga.custoRomaneioTerceirizado,
        custoCarregamento: preCarga.custoCarregamento ? this.converterCustoCarregamentoModelParaCustoDTO(preCarga.custoCarregamento) : null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        salvarCarregamentoComSituacaoBloqueado: preCarga.salvarCarregamentoComSituacaoBloqueado,
        calcularTempoSaida: preCarga.calcularTempoSaida,
        considerarDataPedidoPorCidade: preCarga.considerarDataPedidoPorCidade
      };
    }

  }

  public converterCustoCarregamentoModelParaCustoDTO(
    custoCarregamento: PreCargaCustoCarregamentoModel
  ) {
    if (!custoCarregamento) {
      return {};
    }
    return {
      outrasDespesas: custoCarregamento.outrasDespesas,
      qtdAlimentacaoAdiantamento: custoCarregamento.quantidadeAlimentacao,
      qtdDiarias: custoCarregamento.quantidadeDiaria,
      tipoCarregamento: custoCarregamento.tipoCarregamento,
      valorAlimentacaoAdiantamento: custoCarregamento.valorAlimentacao,
      valorDiarias: custoCarregamento.valorDiaria,
      valorFrete: custoCarregamento.valorFrete,
      valorTotalAlimentacaoAdiantamento:
      custoCarregamento.valorTotalAlimentacao,
      valorTotalDiarias: custoCarregamento.valorTotalDiaria,
      valorDiaria: custoCarregamento.valorDiaria,
      quantidadeDiaria: custoCarregamento.quantidadeDiaria,
      quantidadeAlimentacao: custoCarregamento.quantidadeAlimentacao,
      valorAlimentacao: custoCarregamento.valorAlimentacao,
      kmExcludente: custoCarregamento.kmExcludente,
    };
  }

  public async obterListaDeEntregasSequencia(preCarga: PreCargaModel) {
    let entregaSequenciaList: EntregaSequenciaModel[] = [];
    const solucaoRoteirizacao: SoluctionModel = preCarga.preCargaDTO.solucao;
    const {activities} = solucaoRoteirizacao.vehicleRoutes[0].routes[0];
    const filterByNameActivity = (nameActivity: string) => ({activity}: ActivityModel) => activity === nameActivity;
    const activitiesDriving: ActivityModel[] = activities.filter(filterByNameActivity('DRIVING'));
    const activitiesPoint: ActivityModel[] = activities.filter(({activity}: ActivityModel) => ['CROSSING', 'DELIVERY', 'STOPPING'].includes(activity));

    entregaSequenciaList = await this.montaEntregaSequenciaList(
      activitiesPoint,
      preCarga,
      activitiesDriving,
      this.obterEnderecosClientesPreCarga(preCarga)
    );

    return entregaSequenciaList;
  }

  private obterEnderecosClientesPreCarga(preCarga: PreCargaModel) {
    // Obtém os endereços de dentro dos markers contigos nas pré-cargas
    const enderecoClienteList: EnderecoClienteModel[] =
      this.obterMarkersDaPreCarga(preCarga).map((m) => {
        return {
          idCliente: m.cliente.id,
          idEnderecoEntrega: m.cliente.idEndEntrega,
          endereco: m.cliente.endereco,
          bairro: m.cliente.bairro,
          numero: m.cliente.numero,
          cep: m.cliente.cep,
          cidade: m.cliente.cidade,
        };
      });

    // Verifica se existe algum marker faltando da lista (entregas transferidas)
    // Tratamento necessário, pois em alguns momentos dependendo da manipulação a listaMarkers da pré-carga
    // pode não ser oq realmente está dentro da pré-carga oq pode gerar erros e diversos pontos das funcionalidade
    // por isso os markers são pesquisados diretamente da lista geral de markers verificando de qual pré carga ele pertence pelo id
    const markersPedidoTransf = this.mapUtilService.markers.filter(
      (m) => m.pedidoTransf
    );
    markersPedidoTransf.forEach((marker) => {
      if (
        marker.pedidos.filter((d) => d.idPrecarga === preCarga.id).length > 0
      ) {
        enderecoClienteList.push({
          idCliente: marker.cliente.id,
          idEnderecoEntrega: marker.cliente.idEndEntrega,
          endereco: marker.cliente.endereco,
          bairro: marker.cliente.bairro,
          numero: marker.cliente.numero,
          cep: marker.cliente.cep,
          cidade: marker.cliente.cidade,
        });
      }
    });

    return enderecoClienteList;
  }

  private async montaEntregaSequenciaList(
    activitiesPoint: ActivityModel[],
    preCarga: PreCargaModel,
    activitiesDriving: ActivityModel[],
    enderecosClienteList: EnderecoClienteModel[]
  ) {
    const entregaSequenciaList: EntregaSequenciaModel[] = [];

    for (const activityPoint of activitiesPoint) {
      const index = activitiesPoint.indexOf(activityPoint);
      let activitiesDrive = {
        distance: 0,
        waitTimeToStart: 0,
        startDateTime: new Date(),
        endDateTime: new Date(),
      };

      if (index <= activitiesDriving.length - 1 && activitiesDriving[index]) {
        activitiesDrive = activitiesDriving[index];
      } else if (preCarga.listaEntregas.length === activitiesPoint.length) {
        activitiesDrive = activityPoint;
      }

      const [idCliente, idEndEntrega] = extractStringByDelimiter(activityPoint.site, '_');
      const entrega: EntregaPreCargaModel = this.entregaPreCargaService.obterEntregaPorIdClienteEIdEnderecoEntrega(preCarga.listaEntregas, idCliente, idEndEntrega);
      const markerDaEntrega = preCarga.listaMarkers.find(marker => marker.cliente.id === idCliente && (marker.cliente.idEndEntrega || '0') === idEndEntrega);

      if (entrega) {
        const janelaHabilitada = ['CROSSING', 'STOPPING'].includes(activityPoint.activity)
          ? false
          : await this.validarJanelaEntregaHabilitada(markerDaEntrega, entrega, activityPoint.startDateTime);

        const observacoes = await this.validarObservacoes(entrega);
        entregaSequenciaList.push({
          isPontoPassagem: activityPoint.activity === 'CROSSING',
          isPontoParada: activityPoint.activity === 'STOPPING',
          sequencia: index + 1,
          idCliente,
          idEndEntrega,
          distancia: activitiesDrive.distance,
          nome: entrega.nome,
          fantasia: entrega.fantasia,
          razaoSocial: entrega.razaoSocial,
          endereco: this.obterEnderecoDaEntregaDaListaDeEnderecoCliente(entrega, enderecosClienteList),
          pedidos: convertArrayToString(activityPoint.operations),
          localizacao: {
            latitude: ['CROSSING', 'STOPPING'].includes(activityPoint.activity) ? entrega.localizacao.latitude : entrega.latitude,
            longitude: ['CROSSING', 'STOPPING'].includes(activityPoint.activity) ? entrega.localizacao.longitude : entrega.longitude,
          },
          duracao: activitiesDrive.distance,
          tempoEspera: activityPoint.waitTimeToStart,
          dataHoraInicio: !isNullOrEmpty(activityPoint.startDateTime) ? new Date(activityPoint.startDateTime) : null,
          dataHoraFim: !isNullOrEmpty(activityPoint.endDateTime) ? new Date(activityPoint.endDateTime) : null,
          zonaRisco: entrega.zonaRisco,
          janelaEntrega: janelaHabilitada,
          chaveDeComparacao: entrega.zonaRisco ? 'zonaRisco' : janelaHabilitada ? 'janelaEntrega' : markerDaEntrega.reentrega ?
            'reentrega' : observacoes.length > 0 ? 'temObs' : this.mapUtilService.verificarPossuiPedidoAvulso(markerDaEntrega.pedidos) ?
              'possuiPedidoAvulso' : markerDaEntrega.possuiAgendamento || markerDaEntrega.agendamento ? 'possuiAgendamento' : '',
          identificacaoPersonalizada: ['CROSSING', 'STOPPING'].includes(activityPoint.activity) ?
            false : markerDaEntrega.isIdentificacaoPersonalizada,
          possuiObservacao: ['CROSSING', 'STOPPING'].includes(activityPoint.activity) ? false : markerDaEntrega.possuiObservacao,
          reentrega: ['CROSSING', 'STOPPING'].includes(activityPoint.activity) ? false : markerDaEntrega.reentrega,
          possuiAgendamento: ['CROSSING', 'STOPPING'].includes(activityPoint.activity) ? false : markerDaEntrega.possuiAgendamento,
          listaPedidos: entrega.pedidos,
          ...this.entregaPreCargaService.calcularValores(entrega),
          ultimaParada: entrega.ultimaParada,
          tempoMedio: entrega.original ? entrega.original.tempoMedio : '',
          idPraca: markerDaEntrega.idPraca,
          agendamento: markerDaEntrega.agendamento,
          idRota: markerDaEntrega.cliente.idRota,
          descricaoRota: markerDaEntrega.cliente.descricaoRota,
          obsRota: markerDaEntrega.cliente.obsRota,
          pontoReferencia: markerDaEntrega.cliente.pontoReferencia,
          possuiPedidoAvulso: this.mapUtilService.verificarPossuiPedidoAvulso(markerDaEntrega.pedidos),
          entregaPriorizada: activityPoint.prioritized,
          possuiPedidosEmAtraso: markerDaEntrega.possuiPedidosEmAtraso,
        });
      }
    }
    return entregaSequenciaList;
  }

  async validarObservacoes(entrega) {

    const parametro = await this.paramEspecificoLocalStorageService.getParametroEspecificoLocalStorage('VISUALIZAR_SOMENTE_OBSENTREGA');

    const pedidosComObs = [];

    entrega.pedidos.forEach((pedido) => {
      if ((parametro === 'N' && (pedido.obs || pedido.obs1 || pedido.obs2)) || pedido.obsEntrega || pedido.obsEntrega1 || pedido.obsEntrega2 || pedido.obsEntrega3) {
        pedidosComObs.push(
          {
            numPed: pedido.numeroPedido,
            obs: pedido.obs,
            obs1: pedido.obs1,
            obs2: pedido.obs2,
            obsEntrega: pedido.obsEntrega,
            obsEntrega1: pedido.obsEntrega1,
            obsEntrega2: pedido.obsEntrega2,
            obsEntrega3: pedido.obsEntrega3
          }
        );
      }
    });

    return pedidosComObs;
  }

  private async validarJanelaEntregaHabilitada(marker: MarkerAGM, entrega: EntregaPreCargaModel, startDateTime: Date) {
    if (marker && marker.janelaEntregaHabilitada) {
      const janela = await this.janelaEntregaService.obterPorIdClienteAndIdEnderecoAndDiaSemana(
        entrega.idCliente, entrega.idEnderecoEntrega, new Date(startDateTime)).toPromise();

      return janela.length > 0;
    }
    return false;
  }

  public obterPrevisoesPreCarga(preCarga: PreCargaModel) {
    const rotaSequenciaDtoModel: RotaSequenciaDtoModel =
      new RotaSequenciaDtoModel();
    const solucaoRoteirizacao: SoluctionModel = preCarga.preCargaDTO.solucao;

    const activitiesLoading: ActivityModel[] =
      solucaoRoteirizacao.vehicleRoutes[0].routes[0].activities.filter(
        (activity) => activity.activity === 'LOADING'
      );

    const activitiesDelivery: ActivityModel[] =
      solucaoRoteirizacao.vehicleRoutes[0].routes[0].activities.filter(
        (activity) => activity.activity === 'DELIVERY'
      );

    rotaSequenciaDtoModel.dataSaidaCD = activitiesLoading[0].startDateTime;
    rotaSequenciaDtoModel.dataPrimeiraEntrega =
      activitiesDelivery[0].startDateTime;
    rotaSequenciaDtoModel.dataUltimaEntrega =
      activitiesDelivery[activitiesDelivery.length - 1].startDateTime;
    rotaSequenciaDtoModel.dataRetornoCD =
      activitiesLoading[activitiesLoading.length - 1].startDateTime;
    rotaSequenciaDtoModel.pontoChegada = preCarga.pontoChegada;

    return rotaSequenciaDtoModel;
  }

  private obterEnderecoDaEntregaDaListaDeEnderecoCliente(
    entrega: EntregaPreCargaModel,
    enderecoClienteList: EnderecoClienteModel[]
  ): EnderecoClienteModel {
    return enderecoClienteList.find((end) => {
      const idEndereco = this.obteridEntrega(end.idCliente, end.idEnderecoEntrega);
      const idEndEntrega = this.obteridEntrega(entrega.idCliente, entrega.idEnderecoEntrega);

      return idEndereco === idEndEntrega;
    });
  }

  public transformPreCargaParaGravarCarregamento(preCarga: PreCargaModel) {

    preCarga.listaEntregas.forEach(entrega => {
      const clienteAoQualPertenceAEntrega = preCarga.preCargaDTO.clientes.find(cliente =>
        cliente.id === entrega.idCliente && cliente.idEnderecoEntrega === entrega.idEnderecoEntrega
      );

      if (clienteAoQualPertenceAEntrega) {
        const entregaExistente = clienteAoQualPertenceAEntrega.idsPedidos.some(idPedido =>
          entrega.pedidos.some(pedido => pedido.numeroPedido === idPedido)
        );

        if (!entregaExistente) {
          clienteAoQualPertenceAEntrega.idsPedidos = [
            ...clienteAoQualPertenceAEntrega.idsPedidos,
            ...entrega.pedidos.map(pedido => pedido.numeroPedido)
          ];

          clienteAoQualPertenceAEntrega.listaPedidos = [
            ...clienteAoQualPertenceAEntrega.listaPedidos,
            ...entrega.pedidos.map(pedido => {
              return {
                id: pedido.numeroPedido,
                peso: pedido.pesoTotal,
                valor: pedido.valorTotal,
                volume: pedido.volumeTotal,
                data: pedido.data,
              };
            })
          ];
        }
      }
    });

    const dto: any = preCarga.preCargaDTO;
    dto.veiculo = preCarga.veiculo;
    dto.destino = preCarga.destino;
    dto.motorista = preCarga.motorista;
    dto.rotaInvertida = preCarga.rotaInvertida;
    dto.ajudante1 = preCarga.ajudante1;
    dto.ajudante2 = preCarga.ajudante2;
    dto.ajudante3 = preCarga.ajudante3;
    dto.peso = preCarga.peso;
    dto.observacao = preCarga.observacao;
    dto.volume = preCarga.volume;
    dto.valor = preCarga.valor.toFixed(2);
    dto.custoRomaneioTerceirizado = preCarga.custoRomaneioTerceirizado;
    dto.pontosPassagem = this.obterPontosPassagem(preCarga);
    dto.pontosParada = this.obterPontosParada(preCarga);
    dto.isCrossdocking = this.precargaIsCrossdocking(preCarga);
    dto.rotaPrinc = preCarga.rotaPrinc;
    dto.tipoPontoChegada = preCarga.tipoPontoChegada;
    dto.pontoChegada = preCarga.pontoChegada;
    dto.perfilRoteirizacao = preCarga.perfilRoteirizacao;

    if (preCarga.custoCarregamento) {
      dto.custoCarregamento = this.transformCustoCarregamentoModelParaCustoDTO(preCarga.custoCarregamento);
      dto.custoRomaneioFrete = preCarga.custoRomaneioFrete ? this.criarObjetoCustoRomaneioFrete(preCarga) : null;
    }

    dto.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    dto.salvarCarregamentoComSituacaoBloqueado = preCarga.salvarCarregamentoComSituacaoBloqueado;
    dto.calcularTempoSaida = preCarga.calcularTempoSaida;
    dto.tipoPontoChegada = preCarga.tipoPontoChegada;
    dto.pontoChegada = preCarga.pontoChegada;
    dto.diasEmRota = preCarga.diasEmRota;
    dto.considerarDataPedidoPorCidade = preCarga.considerarDataPedidoPorCidade;

    for (const cliente of dto.clientes) {
      for (const pedido of cliente.listaPedidos) {
        for (const entrega of preCarga.listaEntregas) {
          const pedidoCorrespondente =
             entrega.pedidos.find(p => p.numeroPedido === pedido.id);

          if (pedidoCorrespondente) {
            pedido.reentrega = pedidoCorrespondente.reentrega;
            break;
          }
        }
      }
    }

    return dto;
  }

  private precargaIsCrossdocking(precarga: PreCargaModel): boolean {
    return precarga.listaEntregas.some((entrega) => entrega.pedidos.some((pedido) => pedido.crossdocking));
  }

  public obterPontosParada(precarga) {
    const pontosPassagem = precarga.listaEntregas.filter((entrega: any) => entrega.idCliente.split('_')[0] === 'PR');
    return pontosPassagem.map((ponto: any) => {
      return {
        id: ponto.idCliente + '_' + (ponto.idEndEntrega || 0),
        longitude: ponto.localizacao.longitude,
        latitude: ponto.localizacao.latitude,
        logradouro: ponto.endereco.endereco,
        numero: ponto.endereco.numero,
        bairro: ponto.endereco.bairro,
        municipio: (typeof ponto.endereco.cidade === 'object' ? ponto.endereco.cidade.nome : ponto.endereco.cidade),
        estado: (typeof ponto.original.estado === 'object' ? ponto.original.estado.id : ponto.original.estado),
        cep: ponto.endereco.cep,
        observacao: ponto.original.observacao,
        descricao: ponto.nome,
        tempoMedio: ponto.original.tempoMedio,
        ultimaParada: ponto.original.ultimaParada,
        tipo: ponto.original.tipo,
      };
    });
  }

  public obterPontosPassagem(precarga) {
    const pontosPassagem = precarga.listaEntregas.filter((entrega: any) => entrega.idCliente.split('_')[0] === 'PS');
    return pontosPassagem.map((ponto: any) => {
      return {
        id: ponto.idCliente + '_' + (ponto.idEndEntrega || 0),
        longitude: ponto.localizacao.longitude,
        latitude: ponto.localizacao.latitude
      };
    });
  }

  public transformCustoCarregamentoModelParaCustoDTO(
    custoCarregamento: PreCargaCustoCarregamentoModel
  ) {
    if (!custoCarregamento) {
      return {};
    }
    return {
      outrasDespesas: custoCarregamento.outrasDespesas,
      qtdAlimentacaoAdiantamento: custoCarregamento.quantidadeAlimentacao,
      qtdDiarias: custoCarregamento.quantidadeDiaria,
      tipoCarregamento: custoCarregamento.tipoCarregamento,
      valorAlimentacaoAdiantamento: custoCarregamento.valorAlimentacao,
      valorDiarias: custoCarregamento.valorDiaria,
      valorFrete: custoCarregamento.valorFrete,
      valorTotalAlimentacaoAdiantamento:
      custoCarregamento.valorTotalAlimentacao,
      valorTotalDiarias: custoCarregamento.valorTotalDiaria,
      valorDiaria: custoCarregamento.valorDiaria,
      quantidadeDiaria: custoCarregamento.quantidadeDiaria,
      quantidadeAlimentacao: custoCarregamento.quantidadeAlimentacao,
      valorAlimentacao: custoCarregamento.valorAlimentacao,
      kmExcludente: custoCarregamento.kmExcludente,
    };
  }

  public marcarPreCargasSelecionadas(preCargasSelecionadas: PreCargaModel[]) {
    const idsSelecionados = new Set(preCargasSelecionadas.map((s) => String(s.id)));
    this.listaInternaPreCargas.forEach((p) => {
      if (idsSelecionados.has(String(p.id))) {
        p.select = true;
      }
    });
  }

  public atualizarPreCargasComZonaRisco(preCarga: PreCargaModel) {
    preCarga.listaEntregas = preCarga.listaEntregas.map((entrega) => {
      const zonaRisco = this.mapUtilService.markers.find(
        (x) =>
          x.cliente.id === entrega.idCliente &&
          x.cliente.idEndEntrega === entrega.idEnderecoEntrega
      );
      const possuiZonaRisco = zonaRisco ? zonaRisco.zonaRisco : false;
      entrega.zonaRisco = possuiZonaRisco;
      return entrega;
    });
    return preCarga;
  }

  public carregarPreCargaDTO(preCarga: PreCargaModel) {
    preCarga.preCargaDTO = {
      idPreCarga: preCarga.id,
      destino: preCarga.destino,
      observacao: preCarga.observacao,
      entregaInicial: this.formaDataHoraPeriodoEntrega(
        preCarga.periodoEntregaInicial,
        preCarga.horaPeriodoEntregaInicial
      ),
      entregaFinal: preCarga.periodoEntregaFinal ? this.formaDataHoraPeriodoEntrega(
        preCarga.periodoEntregaFinal,
        preCarga.horaPeriodoEntregaFinal
      ) : null,
      centroDistribuicao: this.preencherCentroDistribuicao(preCarga),
      perfilRoteirizacao: this.preencherPerfilRoteirizacao(preCarga),
      clientes: this.preencherPerfilClientes(preCarga),
      veiculos: this.preencheVeiculo(preCarga),
      motorista: this.preencheMotorista(preCarga),
      primeiraEntrega: this.preencherClientePrimeiraEntrega(preCarga),
      ultimaEntrega: this.preencherClienteUltimaEntrega(preCarga),
      solucao: this.preencherSolucao(preCarga),
      horarioFimOperacao: preCarga.horaPeriodoEntregaFinal,
      horarioInicioAlmoco: preCarga.horarioInicioAlmoco,
      horarioFimAlmoco: preCarga.horarioFimAlmoco,
      calcularTempoSaida: preCarga.calcularTempoSaida,
      horarioInicioOperacao: preCarga.horaPeriodoEntregaInicial,
      tipoPontoChegada: preCarga.tipoPontoChegada,
      pontoChegada: preCarga.pontoChegada,
      considerarDataPedidoPorCidade: preCarga.considerarDataPedidoPorCidade,
    };
    if (preCarga.preCargaDTO) {
      preCarga.preCargaDTO.custoCarregamento =
        this.transformCustoCarregamentoModelParaCustoDTO(
          preCarga.custoCarregamento
        );
    }
  }

  private preencherCentroDistribuicao(preCarga: PreCargaModel) {
    return {
      id: preCarga.centroDistribuicao.id,
      latitude: preCarga.centroDistribuicao.latitude,
      longitude: preCarga.centroDistribuicao.longitude,
      nome: preCarga.centroDistribuicao.nome
    };
  }

  private preencherPerfilRoteirizacao(preCarga: PreCargaModel) {
    return {
      id: preCarga.perfilRoteirizacao.id,
    };
  }

  private preencherPerfilClientes(preCarga: PreCargaModel) {
    return preCarga.listaEntregas.map((entrega) => {
      const marker = this.mapUtilService.markers.find(
        (x) =>
          x.cliente.id === entrega.idCliente &&
          x.cliente.idEndEntrega == entrega.idEnderecoEntrega
      );
      const janelaEntregaHabilitada = (marker && !isNullOrUndefined(marker.janelaEntregaHabilitada)) ?
        marker.janelaEntregaHabilitada : false;

      const agendamento = !marker.agendamento ? null : {
        dataAgendamento: moment(marker.agendamento.data, 'DD/MM/YYYY'),
        horaInicio: marker.agendamento.horaInicial,
        horaFim: marker.agendamento.horaFinal
      };

      return {
        id: entrega.idCliente,
        idEnderecoEntrega: entrega.idEnderecoEntrega,
        latitude: entrega.latitude,
        longitude: entrega.longitude,
        idsPedidos: this.preencherIdPedidos(entrega),
        listaPedidos: this.preencherPedidosDaEntrega(entrega),
        janelaEntregaHabilitada,
        zonaRisco: entrega.zonaRisco,
        agendamento,
        idPedidoAgendamento: marker.agendamento ? marker.agendamento.pedido : null,
        cidade: marker.cliente.cidade,
        estado: marker.cliente.estado,
        idRota: marker.idRota ? marker.idRota : marker.cliente.idRota,
      };
    });
  }

  private preencheVeiculo(o: PreCargaModel) {
    return [
      {
        id: o.veiculo.id,
        placa: o.veiculo.placa,
        peso: (o.veiculo.pesoCarga ? o.veiculo.pesoCarga : o.veiculo.pesoCarregamento),
        volume: (o.veiculo.volume ? o.veiculo.volume : o.veiculo.volumeCarregamento),
        precoLitroCombustivel: o.veiculo.precoLitroCombustivel,
        consumoMedio: o.veiculo.consumoMedio,
      },
    ];
  }

  private preencheMotorista(o: PreCargaModel) {
    return {
      id: o.motorista.id,
      nome: o.motorista.nome,
      apelido: o.motorista.apelido,
      idFilial: o.motorista.idFilial,
      cargaHoraria: o.motorista.cargaHoraria,
      custoHora: o.motorista.custoHora,
    };
  }

  private preencherIdPedidos(entrega: EntregaPreCargaModel) {
    return entrega.pedidos.map((p) => p.numeroPedido);
  }

  private preencherPedidosDaEntrega(entrega: EntregaPreCargaModel) {
    return entrega.pedidos.map((pedido) => {
      return {
        id: pedido.numeroPedido,
        peso: pedido.pesoTotal,
        volume: pedido.volumeTotal,
        valor: pedido.valorTotal,
        data: pedido.data,
      };
    });
  }

  public preencherClientePrimeiraEntrega(preCarga: PreCargaModel) {
    if (preCarga.primeiraEntrega) {
      return {
        id: preCarga.primeiraEntrega.idCliente,
        idEnderecoEntrega: preCarga.primeiraEntrega.idEnderecoEntrega,
      };
    }

    return {};
  }

  private preencherClienteUltimaEntrega(preCarga: PreCargaModel) {
    if (preCarga.ultimaEntrega) {
      return {
        id: preCarga.ultimaEntrega.idCliente,
        idEnderecoEntrega: preCarga.ultimaEntrega.idEnderecoEntrega,
      };
    }

    return {};
  }

  private formaDataHoraPeriodoEntrega(dataEntrega, horaEntrega) {
    const periodoEntregaCompleto = new Date(dataEntrega);
    const horaPeriodoEntrega = horaEntrega.split(':');
    periodoEntregaCompleto.setHours(horaPeriodoEntrega[0]);
    periodoEntregaCompleto.setMinutes(horaPeriodoEntrega[1]);

    return periodoEntregaCompleto;
  }

  private preencherSolucao(preCarga: PreCargaModel): any {
    if (preCarga.preCargaDTO && preCarga.preCargaDTO.solucao) {
      return Object.assign({}, preCarga.preCargaDTO.solucao);
    }

    return null;
  }

  public transformPreCargaDtoToPreCargaModel(dto: PreCargaDTO) {
    const cor = this.gerarCorAleatoria();
    return {
      id: dto.idPreCarga,
      destino: dto.destino,
      veiculo: dto.veiculos[0],
      centroDistribuicao: dto.centroDistribuicao,
      horaPeriodoEntregaFinal: dto.horarioFimOperacao,
      horaPeriodoEntregaInicial: dto.horarioInicioOperacao,
      listaEntregas: dto.clientes,
      periodoEntregaInicial: dto.entregaInicial,
      periodoEntregaFinal: dto.entregaFinal,
      perfilRoteirizacao: dto.perfilRoteirizacao,
      tipoPontoChegada: dto.tipoPontoChegada,
      pontoChegada: dto.pontoChegada,
      cor,
      preCargaDTO: dto
    };
  }

  criarObjetoCustoRomaneioFrete(preCarga) {
    if (!isNullOrUndefined(preCarga) && preCarga.custoRomaneioFrete) {
      return {
        idTabelaFrete: preCarga.custoCarregamento.tabelaFrete.id,
        descricao: preCarga.custoCarregamento.tabelaFrete.descricao,
        valorTotal: preCarga.custoRomaneioFrete.valorTotal,
        valorAdicional: preCarga.custoRomaneioFrete.valorAdicional,
        romaneio: null,
        alimentacao: preCarga.custoRomaneioFrete.alimentacao,
        diaria: preCarga.custoRomaneioFrete.diaria,
        outrasDespesas: preCarga.custoRomaneioFrete.outrasDespesas,
        tipoFaixa: preCarga.custoRomaneioFrete.tipoFaixa,
        valorEntrega: preCarga.custoRomaneioFrete.valorEntrega,
        valorFrete: preCarga.custoRomaneioFrete.valorFrete,
        valorCombustivel: preCarga.custoRomaneioFrete.valorCombustivel,
        valor: preCarga.custoRomaneioFrete.valor,
        inicio: preCarga.custoRomaneioFrete.inicio,
        fim: preCarga.custoRomaneioFrete.fim,
        valorTonelada: preCarga.custoRomaneioFrete.valorTonelada,
        taxaDificuldadeEntrega: preCarga.custoRomaneioFrete.taxaDificuldadeEntrega,
        cidadesCarga: preCarga.custoRomaneioFrete.cidadesCarga,
        tipoFaixaCidade: preCarga.custoRomaneioFrete.tipoFaixaCidade,
        idMotorista: preCarga.custoRomaneioFrete.idMotorista,
        custoMotorista: preCarga.custoRomaneioFrete.custoMotorista,
        custoAjudantes: preCarga.custoRomaneioFrete.custoAjudantes,
        valorMinimo: preCarga.custoRomaneioFrete.tabelaFrete.valorMinimo,
        faixasCarga: preCarga.custoRomaneioFrete.faixasCarga,
        tokenValidacaoTabelaFrete: preCarga.tokenValidacaoTabelaFrete,
        valorFreteDiasUteis: preCarga.custoRomaneioFrete.valorFreteDiasUteis,
        qtdDiasViagem: preCarga.custoRomaneioFrete.qtdDiasViagem,
        qtdDiasUteisUtilizado: preCarga.custoRomaneioFrete.qtdDiasUteisUtilizado,
        fornecedoresCarga: preCarga.custoRomaneioFrete.fornecedoresCarga,
        kmExcludente: preCarga.custoRomaneioFrete.kmExcludente,
        valorBaseDiariaAjudantes: preCarga.custoCarregamento.tabelaFrete.valorDiariaAjudantes,
      };
    }
    return null;
  }

  obterCusto(preCarga: PreCargaModel) {
    const tipoCusto = preCarga.custoCarregamento ? preCarga.custoCarregamento.tipoCarregamento : null;

    if (tipoCusto == 'TF') {
      const custoTabelaFrete = preCarga.custoRomaneioFrete;
      return custoTabelaFrete != null ? (custoTabelaFrete.valorTotal + custoTabelaFrete.valorAdicional) : 0;
    } else if (tipoCusto == 'T') {
      const custoFrete = preCarga.custoCarregamento.valorFrete;
      return custoFrete ? custoFrete : 0;
    } else {
      const custoProprio = preCarga.custoProprio;
      return custoProprio ? custoProprio.custoTotal : 0;
    }
  }

  public async montarObjModalVisualizacaoRota(preCargaModel: PreCargaModel, custoCarregamento, custoRomaneioFrete): Promise<MapaEntregasModel> {
    const entregas = await this.obterListaDeEntregasSequencia(preCargaModel);

    const {
      periodoEntregaInicial,
      horaPeriodoEntregaInicial,
      periodoEntregaFinal,
      horaPeriodoEntregaFinal,
      carregamentoGravadoDTO
    } = preCargaModel;
    const horaInicial = Number(horaPeriodoEntregaInicial.split(':')[0]);
    const minutoInicial = Number(horaPeriodoEntregaInicial.split(':')[1]);

    const horaFinal = Number(horaPeriodoEntregaFinal.split(':')[0]);
    const minutoFinal = Number(horaPeriodoEntregaFinal.split(':')[1]);

    return {
      entregas,
      dataEntregaInicial: moment(periodoEntregaInicial, 'yyyy-MM-DD').hour(horaInicial).minute(minutoInicial).toDate(),
      dataEntregaFinal: moment(periodoEntregaFinal, 'yyyy-MM-DD').hour(horaFinal).minute(minutoFinal).toDate(),
      horarioFimOperacao: preCargaModel.horaPeriodoEntregaFinal,
      centroDistribuicao: preCargaModel.centroDistribuicao,
      distanciaTotalDaRota: preCargaModel.preCargaDTO.solucao.indicators.totalDistance,
      destinoRota: preCargaModel.destino,
      nomeMotorista: preCargaModel.motorista.nome,
      idMotorista: preCargaModel.motorista.id,
      idVeiculo: preCargaModel.veiculo.id,
      idCarregamento: carregamentoGravadoDTO ? carregamentoGravadoDTO.id : null,
      corMarkers: preCargaModel.cor,
      solucaoRoteirizacao: preCargaModel.preCargaDTO.solucao,
      rotaInvertida: preCargaModel.rotaInvertida,
      datasInicialFinalRetorno: this.obterPrevisoesPreCarga(preCargaModel),
      custoCarregamento,
      custoRomaneioFrete,
      preCargaModel,
      isActiveDelete: true,
      isActiveVerObs: true,
      calcularTempoSaida: preCargaModel.calcularTempoSaida,
      perfilRoteirizacao: preCargaModel.perfilRoteirizacao,
      tipoPontoChegada: preCargaModel.tipoPontoChegada,
      pontoChegada: preCargaModel.pontoChegada,
    };
  }

  public atualizarSolucaoRoteirizacao(
    solucaoRoteirizacao: SoluctionModel,
    polylineCoordinateRoutes: any,
    tripSoluction: TripSoluctionModel,
    entregas: EntregaSequenciaModel[],
    idCentroDistribuicao: number
  ) {
    // Adaptação realizada para integração do hub --------------------------------------------------------------------------------
    // Realiza a atualização do vehicleRoutes dentro da solução (O vehicleRoutes foi atualizado ao recalcular o trajeto)

    // if (solucaoRoteirizacao) {
    solucaoRoteirizacao.vehicleRoutes = tripSoluction.vehicleRoutes;

    // Fluxo normal já implementado anteriormente (antes do hub) -----------------------------------------------------------------
    const listaDrivings =
      solucaoRoteirizacao.vehicleRoutes[0].routes[0].activities.filter(
        (activity) => activity.activity === 'DRIVING'
      );
    listaDrivings.forEach((activity, index) => {
      activity.distance = tripSoluction.legs[index].distance;
      activity.nominalDuration = tripSoluction.legs[index].nominalDuration;

      // a lista de entregas sera sempre menor que a tripSoluction
      if (index < entregas.length) {
        entregas[index].distancia = tripSoluction.legs[index].distance;
        entregas[index].duracao = tripSoluction.legs[index].nominalDuration;
        entregas[index].tempoEspera = tripSoluction.legs[index].waitTimeToStart;
        entregas[index].entregaPriorizada = tripSoluction.legs[index].prioritized;

        if (!isNullOrEmpty(tripSoluction.legs[index].arrivalTime)) {
          entregas[index].dataHoraInicio = new Date(
            tripSoluction.legs[index].arrivalTime
          );
        }

        if (!isNullOrEmpty(tripSoluction.legs[index].departureTime)) {
          entregas[index].dataHoraFim = new Date(
            tripSoluction.legs[index].departureTime
          );
        }
      }

      if (index === 0) {
        activity.departureSite = `CD_${idCentroDistribuicao}`;
      } else {
        activity.departureSite = `${entregas[index - 1].idCliente}_${entregas[index - 1].idEndEntrega
        }`;
      }
      if (
        index + 1 ===
        solucaoRoteirizacao.vehicleRoutes[0].routes[0].activities.filter(
          (atv) => atv.activity === 'DRIVING'
        ).length
      ) {
        activity.arrivalSite = `CD_${idCentroDistribuicao}`;
      } else {
        activity.arrivalSite = `${entregas[index].idCliente}_${entregas[index].idEndEntrega}`;
      }
    });

    solucaoRoteirizacao.indicators.totalDistance = tripSoluction.totalDistance;
    solucaoRoteirizacao.indicators.totalDrivingTime =
      tripSoluction.totalNominalDuration;

    return solucaoRoteirizacao;
  }

  salvarCopiaPreCargasAntesDaTransferencia() {
    this.copiaPreCargasAntesDaTransferencia = cloneDeep(this.listaInternaPreCargas);
  }

  getCopiaPreCargasAntesDaTransferencia() {
    return this.copiaPreCargasAntesDaTransferencia;
  }

  atualizarListaPreCargas(listaPreCargas: PreCargaModel[]) {
    this.listaInternaPreCargas = cloneDeep(listaPreCargas);
    this.atualizarListaPrecargaStorage();
  }

  obterInfoEntregasRota(preCarga: PreCargaModel): InfoEntregasRotaModel[] {

    const idEntregaNull = (ie) => ie === null ? '0' : ie;

    try {

      if (!this.preCargaRoteirizadaCorretamente(preCarga)) {
        Error('Pre-carga não roteirizada corretamente');
      }

      const activities = preCarga.preCargaDTO.solucao.vehicleRoutes['0'].routes['0'].activities;
      let distanciaCD = 0;
      const retorno = activities.filter((activity) => activity.activity === 'DRIVING').map((activity, index) => {
        const distancia = activity.distance;
        const ponto = activity.arrivalSite.split('_');
        const pontoPartida = activity.departureSite;
        distanciaCD = distanciaCD + (distancia / 1000);
        const entrega = preCarga.listaEntregas.find((e) => e.idCliente === ponto[0] && idEntregaNull(e.idEnderecoEntrega) === ponto[1]);
        const peso = isNullOrUndefined(entrega) ? 0 : entrega.pedidos.reduce((acc, pedido) => acc + pedido.pesoTotal, 0);
        const volume = isNullOrUndefined(entrega) ? 0 : entrega.pedidos.reduce((acc, pedido) => acc + pedido.volumeTotal, 0);
        const valor = isNullOrUndefined(entrega) ? 0 : entrega.pedidos.reduce((acc, pedido) => acc + pedido.valorTotal, 0);
        const idsPedidos = isNullOrUndefined(entrega) ? [] : entrega.pedidos.map((pedido) => pedido.numeroPedido);
        return {
          distancia,
          cliente: ponto[0],
          idEndEntrega: ponto[1],
          pontoPartida,
          dataHoraInicio: activity.startDateTime,
          dataHoraFim: activity.endDateTime,
          duracao: activity.nominalDuration,
          tempoEspera: activity.waitTimeToStart,
          distanciaCD,
          peso,
          volume,
          valor,
          idsPedidos,
        };
      });

      return retorno.filter((info) => !['CD', 'PS', 'PR'].includes(info.cliente));
    } catch (error) {
      console.log('Erro ao obter informações sobre as entregas', error);
    }

  }

  existePrecargaEmProcessoSalvar(): boolean {
    return this.listaInternaPreCargas.some(precarga => precarga.isProcessoSalvar && this.preCargaSalvamentoEmAndamento(precarga));
  }

  // Validando ou gravando: ainda aguarda retorno do backend, diferente de erro ou aguardando confirmação do usuário
  preCargaSalvamentoEmAndamento(preCarga: PreCargaModel): boolean {
    return !preCarga.situacaoSalvar
      || preCarga.situacaoSalvar === SituacaoSalvarPreCarga.VALIDANDO
      || preCarga.situacaoSalvar === SituacaoSalvarPreCarga.GRAVANDO;
  }

  obterPreCargasEmProcessoSalvar(): PreCargaModel[] {
    return this.listaPreCargas.filter(precarga => precarga.isProcessoSalvar);
  }

  exibirOcultarClientes(tipo?: TipoExibicaoClienteMapaModel) {
    if (!tipo) {
      tipo = this.tipoExibicaoClienteMapa;
    }

    switch (tipo) {
      case TipoExibicaoClienteMapaModel.TODOS:
        const markersEmProcessoSalvarTodos = this.obterMarkersEmProcessoSalvar();
        this.mapUtilService.markers.forEach(marker => {
          marker.isVisivel = !markersEmProcessoSalvarTodos.has(marker);
        });
        this.tipoExibicaoClienteMapa = TipoExibicaoClienteMapaModel.TODOS;
        break;

      case TipoExibicaoClienteMapaModel.EM_PRE_CARGA:
        const markersVisiveis = new Set(
          this.listaPreCargas.reduce((acc, preCarga) => {
            if (!preCarga.isProcessoSalvar) {
              acc = acc.concat(preCarga.listaMarkers);
            }
            return acc;
          }, [])
        );
        this.mapUtilService.markers.forEach(marker => {
          marker.isVisivel = markersVisiveis.has(marker);
        });
        this.tipoExibicaoClienteMapa = TipoExibicaoClienteMapaModel.EM_PRE_CARGA;
        break;

      case TipoExibicaoClienteMapaModel.SEM_PRE_CARGA:
        const markersOcultos = new Set(
          this.listaPreCargas.reduce((acc, preCarga) => acc.concat(preCarga.listaMarkers), [])
        );
        this.mapUtilService.markers.forEach(marker => {
          marker.isVisivel = !markersOcultos.has(marker);
        });
        this.tipoExibicaoClienteMapa = TipoExibicaoClienteMapaModel.SEM_PRE_CARGA;
        break;

      case TipoExibicaoClienteMapaModel.ROTEIRIZADOS:
        const markersRoteirizados = new Set(
          this.listaPreCargas.reduce((acc, preCarga) => {
            if (this.preCargaRoteirizadaCorretamente(preCarga)) {
              acc = acc.concat(preCarga.listaMarkers);
            }
            return acc;
          }, [])
        );
        this.mapUtilService.markers.forEach(marker => {
          marker.isVisivel = markersRoteirizados.has(marker);
        });
        this.tipoExibicaoClienteMapa = TipoExibicaoClienteMapaModel.ROTEIRIZADOS;
        break;

      case TipoExibicaoClienteMapaModel.NAO_ROTEIRIZADOS:
        const markersNaoRoteirizados = new Set(
          this.listaPreCargas.reduce((acc, preCarga) => {
            if (!this.preCargaRoteirizadaCorretamente(preCarga)) {
              acc = acc.concat(preCarga.listaMarkers);
            }
            return acc;
          }, [])
        );
        this.mapUtilService.markers.forEach(marker => {
          marker.isVisivel = markersNaoRoteirizados.has(marker);
        });
        this.tipoExibicaoClienteMapa = TipoExibicaoClienteMapaModel.NAO_ROTEIRIZADOS;
        break;

      default:
        const markersEmProcessoSalvarPadrao = this.obterMarkersEmProcessoSalvar();
        this.mapUtilService.markers.forEach(marker => {
          marker.isVisivel = !markersEmProcessoSalvarPadrao.has(marker);
        });
        this.tipoExibicaoClienteMapa = TipoExibicaoClienteMapaModel.TODOS;
        break;
    }

    // Independente do tipo de exibição, os pins das pré-cargas em processo de salvamento permanecem ocultos
    const markersEmProcessoSalvar = this.obterMarkersEmProcessoSalvar();
    if (markersEmProcessoSalvar.size) {
      this.mapUtilService.markers.forEach(marker => {
        if (markersEmProcessoSalvar.has(marker)) {
          marker.isVisivel = false;
        }
      });
    }

    this.tipoExibicaoClienteMapa = tipo;
  }

  isMarkerEmProcessoSalvar(marker: any): boolean {
    return this.listaInternaPreCargas.some(preCarga =>
      preCarga.isProcessoSalvar && preCarga.listaMarkers.includes(marker)
    );
  }


  obterQuantidadeClientesSelecionados() {
    return this.obterListaClientesSelecionados().length;
  }

  obterListaPedidosPorIdPreCarga(idPreCarga) {
    const preCarga = this.obterPreCargaPorId(idPreCarga);

    if (!preCarga) {
      return [];
    }

    return preCarga.listaEntregas.reduce((acc, entrega) => acc.concat(entrega.pedidos), []);
  }

  /**
   * Usa a lista interna (sem retotalizar todas as pré-cargas) e push em vez de concat acumulado,
   * que copiava o array a cada entrega. Chamado a cada clique nos checkboxes da grid.
   */
  obterListaPedidosSelecionados(): PedidosPreCargaModel[] {
    const pedidosSelecionados: PedidosPreCargaModel[] = [];
    this.listaInternaPreCargas.forEach(precarga => {
      precarga.listaEntregas.forEach(entrega => {
        entrega.pedidos.forEach(pedido => {
          if (pedido.select) {
            pedidosSelecionados.push(pedido);
          }
        });
      });
    });
    return pedidosSelecionados;
  }

  existePedidosSelecionados() {
    return this.listaInternaPreCargas.some(preCarga => preCarga.listaEntregas.some(entrega =>
      entrega.pedidos.some(pedido => pedido.select)
    ));
  }

  existePedidosReentregaNaPrecargas(preCargas: PreCargaModel[]): boolean {
    return preCargas.some(preCarga => preCarga.listaEntregas.some(entrega =>
      entrega.pedidos.some(pedido => pedido.reentrega)
    ));
  }

}
